<template>
  <MainBreadcrumb
    :items="items"
    showBackButton
  />
  <MainButtonsBar :align="'space-between'">
    <template #left>
      <CustomTitle>Detalle de propuesta comercial</CustomTitle>
    </template>
    <template #right>
      <el-button
        type="primary"
        size="default"
        :icon="IconEdit"
        @click="editItem"
        >Editar</el-button
      >
    </template>
  </MainButtonsBar>

  <DetailContainer> </DetailContainer>
</template>

<script setup>
import { onBeforeMount } from 'vue';
import {
  useRoute,
  useRouter,
} from 'vue-router';
// import { storeToRefs } from 'pinia';
import { useProposalsStore } from '../proposals_store.js';
import CustomTitle from '@/shared/components/custom_title.vue';
import DetailContainer from '@/shared/layout/detail/detail_container.vue';
import IconEdit from '~icons/mdi/edit';
import MainBreadcrumb from '@/shared/layout/main/main_breadcrum.vue';
import MainButtonsBar from '@/shared/layout/main/buttons_bar/main_buttons_bar.vue';

const route = useRoute();
const router = useRouter();
const proposalsStore = useProposalsStore();
const { findProposalByCodigoHTTP } = proposalsStore;

// local state
const items = [
  { label: 'Inicio', to: '/page/proposals/list', replace: false },
  { label: 'Detalle', to: null, replace: false },
];

const editItem = () => router.replace(`/page/proposals/edit/${route.params.id}`);

onBeforeMount(() => {
  const id = route.params.id; // id de la ruta o del objecto de lista
  if (+route.params.id > 0) {
    findProposalByCodigoHTTP(id);
  }
});
</script>

<style scoped></style>
